import { OrderBillingDto } from './order-billing-dto';

export class SplitPaymentDto extends OrderBillingDto {
  splitAmount = 0;
}
